import style from "../style/card.module.css";

export default function Card({ list, result, startGame, resultPage }) {
  return (
    <div className={`${style.card} ${resultPage ? style.card_mob : undefined}`}>
      <div className={style.card_img}>
        <img src={list?.image} alt={list.name} />
      </div>

      {startGame && (
        <button
          type="button"
          onClick={() => startGame(list, result)}
          className={style.selectBtn}
        >
          선택하기
        </button>
      )}
    </div>
  );
}
